'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import useAsync from 'react-use/lib/useAsync';
import { initAuth } from '../store.tsx';
export const AuthProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    isAuthCompassion: t1
  } = t0;
  const isAuthCompassion = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isAuthCompassion) {
    t2 = async () => {
      await initAuth(isAuthCompassion);
    };
    $[0] = isAuthCompassion;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useAsync(t2, t3);
  let t4;
  if ($[3] !== children) {
    t4 = <>{children}</>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};